import { FORM_DATA_INITIAL } from 'ui/screen/pomodoro/partials'
import { create } from 'zustand'
import { POMODORO_STATUS } from '@constants'

const usePomodoroStore = create((set, get) => ({
  // Estado do pomodoro
  status: POMODORO_STATUS.INITIAL,
  formData: { ...FORM_DATA_INITIAL },
  settingsList: null,
  pomodoroId: null,
  selectedConfig: null,
  activePomodoro: {
    title: '',
    time: null,
  },
  pomodoroSettings: {
    focus: 1,
    shortBreak: 0,
    longBreak: 0,
    allPomodoro: false,
  },
  isModalOpen: false,
  progressValue: 0,

  // Timer state
  timerState: {
    hours: 0,
    minutes: 0,
    seconds: 0,
    isRunning: false,
    expiryTimestamp: new Date(),
    remainingSeconds: null,
    focusStartedAt: null,
  },

  // Actions
  setStatus: status => set({ status }),
  setFormData: formData =>
    set(state => ({
      formData:
        typeof formData === 'function' ? formData(state.formData) : formData,
    })),
  setSettingsList: settingsList => set({ settingsList }),
  setPomodoroId: pomodoroId => set({ pomodoroId }),
  setSelectedConfig: selectedConfig => set({ selectedConfig }),
  setActivePomodoro: activePomodoro => set({ activePomodoro }),
  setPomodoroSettings: pomodoroSettings =>
    set(state => ({
      pomodoroSettings:
        typeof pomodoroSettings === 'function'
          ? pomodoroSettings(state.pomodoroSettings)
          : pomodoroSettings,
    })),
  setIsModalOpen: isModalOpen => set({ isModalOpen }),
  setProgressValue: progressValue => set({ progressValue }),

  // Timer actions
  setTimerState: timerState =>
    set(state => ({
      timerState:
        typeof timerState === 'function'
          ? timerState(state.timerState)
          : timerState,
    })),
  updateTimer: updates =>
    set(state => ({
      timerState: { ...state.timerState, ...updates },
    })),

  // Reset pomodoro
  resetPomodoro: () =>
    set({
      status: POMODORO_STATUS.INITIAL,
      formData: { ...FORM_DATA_INITIAL },
      pomodoroId: null,
      selectedConfig: null,
      activePomodoro: {
        title: '',
        time: null,
      },
      progressValue: 0,
      timerState: {
        hours: 0,
        minutes: 0,
        seconds: 0,
        isRunning: false,
        expiryTimestamp: new Date(),
        remainingSeconds: null,
        focusStartedAt: null,
      },
    }),

  // Start timer
  startTimer: () =>
    set(state => ({
      timerState: { ...state.timerState, isRunning: true },
    })),

  // Pause timer
  pauseTimer: () =>
    set(state => ({
      timerState: { ...state.timerState, isRunning: false },
    })),

  // Restart timer
  restartTimer: expiryTimestamp =>
    set(state => ({
      timerState: {
        ...state.timerState,
        expiryTimestamp,
        isRunning: false,
      },
    })),
}))

export { usePomodoroStore }
